import { render, staticRenderFns } from "./App.vue?vue&type=template&id=91ac6b5c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91ac6b5c')) {
      api.createRecord('91ac6b5c', component.options)
    } else {
      api.reload('91ac6b5c', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=91ac6b5c", function () {
      api.rerender('91ac6b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/App.vue"
export default component.exports